import { Button } from '@/components/ui/button';
import { whatsappLink } from '../site-config';
import { SiteContainer } from '../SiteUi';

const CHAIN = [
  { label: 'OS-1042', hint: 'Serviço finalizado', accent: false },
  { label: '90 dias', hint: 'Intervalo da oficina', accent: false },
  { label: 'WhatsApp', hint: 'Lembrete enviado', accent: false },
  { label: 'Retorno', hint: 'Cliente volta', accent: true },
];

export function SiteCtaFinal() {
  return (
    <section className="bg-[#0e1a28] py-16 text-white sm:py-20">
      <SiteContainer className="grid items-center gap-10 lg:grid-cols-[minmax(0,1.15fr)_minmax(16rem,0.85fr)] lg:gap-16">
        <div>
          <p className="text-sm text-white/55">Sua equipe já tem trabalho suficiente.</p>
          <h2 className="mt-3 max-w-[18ch] font-display text-[clamp(2rem,4.5vw,3.75rem)] font-semibold leading-[1.02] tracking-tight">
            Deixe o AgilizaOS lembrar, cobrar e acompanhar por ela.
          </h2>
          <p className="mt-4 max-w-[46ch] text-base leading-relaxed text-white/65">
            Veja em uma demonstração como uma OS finalizada pode virar o próximo atendimento automaticamente.
          </p>
          <div className="mt-6">
            <Button asChild variant="default">
              <a href={whatsappLink('Olá! Quero ver uma demonstração do AgilizaOS.')} target="_blank" rel="noopener noreferrer">
                Conversar no WhatsApp
              </a>
            </Button>
          </div>
          <p className="mt-5 text-sm text-white/45">Sem formulário. Você fala direto com a gente.</p>
        </div>

        <ol className="border border-white/10 px-5 py-5">
          {CHAIN.map((step, index) => (
            <li key={step.label} className={index > 0 ? 'mt-4 border-t border-white/10 pt-4' : ''}>
              <p className={`font-os text-sm ${step.accent ? 'text-[#f5821f]' : 'text-white'}`}>{step.label}</p>
              <p className="mt-1 text-sm text-white/50">{step.hint}</p>
            </li>
          ))}
        </ol>
      </SiteContainer>
    </section>
  );
}
